import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { APP_ROUTING } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './Shared/header/header.component';
import { FooterComponent } from './Shared/footer/footer.component';
import { InicioComponent } from './Components/inicio/inicio.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PrimerComponent } from './Components/primer/primer.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule} from '@angular/common/http';
import { NopaginaComponent } from './Components/nopagina/nopagina.component';

import { GoogleAnalyticsService} from '../app/Components/google-analytics.service';
import { MenuComponent } from './Components/menu/menu.component';
import { FormularioComponent } from './Components/formulario/formulario.component';
import { HeaderlogComponent } from './Shared/headerlog/headerlog.component';
import { FontAwesomeModule, FaIconLibrary  } from '@fortawesome/angular-fontawesome';
import { faBars, faSignOutAlt, faSignInAlt, faFileSignature, faCheckCircle, faTimesCircle, faTimes, faSearch, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { RutEmpresaFormComponent } from './Components/rut-empresa-form/rut-empresa-form.component';
import { EmpresaFormComponent } from './Components/empresa-form/empresa-form.component';
import { RepresentLegalFormComponent } from './Components/represent-legal-form/represent-legal-form.component';

import { ListaEmpresasService } from './Services/lista-empresas.service';
import { DetalleUsuarioService } from './Services/detalle-usuario.service';
import { ParametroAccionService } from './Services/parametro-accion.service';
import { ModalAproRepLegComponent } from './Components/modal-apro-rep-leg/modal-apro-rep-leg.component';
import { ModalRechRepLegComponent } from './Components/modal-rech-rep-leg/modal-rech-rep-leg.component';
import { DetSolicitudComponent } from './Components/det-solicitud/det-solicitud.component';
import { ModalAproSolComponent } from './Components/modal-apro-sol/modal-apro-sol.component';
import { ModalRechSolComponent } from './Components/modal-rech-sol/modal-rech-sol.component';
import { ModalCertDdjjFormComponent } from './Components/modal-cert-ddjj-form/modal-cert-ddjj-form.component';
import { CertDdjjVpComponent } from './Components/cert-ddjj-vp/cert-ddjj-vp.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    InicioComponent,
    PrimerComponent,
    NopaginaComponent,
    MenuComponent,
    FormularioComponent,
    HeaderlogComponent,
    RutEmpresaFormComponent,
    EmpresaFormComponent,
    RepresentLegalFormComponent,
    ModalAproRepLegComponent,
    ModalRechRepLegComponent,
    DetSolicitudComponent,
    ModalAproSolComponent,
    ModalRechSolComponent,
    ModalCertDdjjFormComponent,
    CertDdjjVpComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTING,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 6000,
      closeButton: true,
      tapToDismiss: false
    })
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/certificadoHonorariosDCyF/' }, 
    GoogleAnalyticsService, 
    ListaEmpresasService, 
    DetalleUsuarioService,
    ParametroAccionService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    // Add an icon to the library for convenient access in other components
    library.addIcons(faBars);
    library.addIcons(faSignOutAlt);
    library.addIcons(faSignInAlt);
    library.addIcons(faFileSignature);
    library.addIcons(faCheckCircle);
    library.addIcons(faTimesCircle);
    library.addIcons(faTimes);
    library.addIcons(faSearch);
    library.addIcons(faArrowLeft);
  }
}
